import { ErrorMessage } from "@hookform/error-message";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { toast } from "react-toastify";
import { Modal, ModalBody } from "reactstrap";
import {
  Button,
  Col,
  Icon,
  Row,
  RSelect,
} from "../../components/Component";
import { GET, POST } from "../../helper/api";
import { INVENTORY_FUEL_CATEGORY } from "../../utils/Utils";
import moment from "moment";

const INVENTORY_FUEL_CATEGORY_OPTIONS = Object.keys(INVENTORY_FUEL_CATEGORY).map((c) => ({
  label: INVENTORY_FUEL_CATEGORY[c],
  value: c,
}));

const DEFAULT_EXCHANGE_QUANTITY = {
  category: null,
  quantity: null,
  fromWarehouseId: null,
  toWarehouseId: null,
  date: null,
};

const ExchangeInventory = ({ resetData: onResetData }) => {
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const {
    errors,
    handleSubmit,
    reset,
    getValues,
    control,
    setValue,
    watch,
    register
  } = useForm({
    defaultValues: DEFAULT_EXCHANGE_QUANTITY,
  });

  const fromWarehouseId = watch('fromWarehouseId');

  const [view, setView] = useState({
    exchangeQuantity: false,
  });
  useEffect(() => {
    GET("/warehouse", {}, true).then((resp) => {
      setWarehouseOptions(
        resp.data?.rows?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          })
        )
      );
    });
  }, [])

  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ exchangeQuantity: false });
    reset(DEFAULT_EXCHANGE_QUANTITY);
  };

  const resetData = () => {
    onFormCancel();
    onResetData();
  };

  // Submits form data
  const onHandleSubmit = () => {
    const {
      quantity,
      category,
      fromWarehouseId,
      toWarehouseId,
      date,
    } = getValues();

    const formData = {
      quantity,
      category,
      fromWarehouseId,
      toWarehouseId,
      date,
    };

    POST("inventory/exchange-quantity", formData, {}, true)
      .then((res) => {
        toast.success("Cập nhật thành công");
        resetData();
      })
      .catch(({ response }) => {

        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại 1."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };



  return (
    <>
      <Button color="primary" onClick={() => {
        toggle('exchangeQuantity');
      }}>
        <span>Chuyển kho nội bộ</span>
      </Button>

      <Modal
        isOpen={view.exchangeQuantity}
        toggle={() => onFormCancel()}
        className="modal-dialog-centered"
        size="lg"
      >
        <ModalBody>
          <a href="#cancel" className="close">
            {" "}
            <Icon
              name="cross-sm"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
            ></Icon>
          </a>
          <div className="p-2">
            <h5 className="title">Chuyển kho</h5>
            <div className="mt-4">
              <form onSubmit={handleSubmit(onHandleSubmit)}>
                <Row className="g-3">
                  <Col md="12">
                    <div className="form-group">
                      <label className="form-label" htmlFor="date">
                        Ngày <span className="text-danger">*</span>
                      </label>
                      <div className="form-control-wrap">
                        <input
                          className="form-control"
                          type="datetime-local"
                          name="date"
                          ref={register({
                            required: "Vui lòng nhập thông tin",
                          })}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="date"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col md="12">
                    <div className="form-group">
                      <label className="form-label" htmlFor="warehouseId">
                        Từ kho <span className="text-danger">*</span>
                      </label>
                      <div className="form-control-wrap">
                        <Controller
                          control={control}
                          name="fromWarehouseId"
                          rules={{ required: "Vui lòng nhập thông tin" }}

                          render={({ onChange, value, name, ref }) => (
                            <RSelect
                              isClearable
                              classNamePrefix="form-control"
                              inputRef={ref}
                              name={name}
                              options={warehouseOptions}
                              value={warehouseOptions.find(
                                (c) => c.value === value
                              ) || null}
                              onChange={(val) => {
                                onChange(val?.value);
                                setValue('toWarehouseId', null);
                              }}
                            />
                          )}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="warehouseId"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col md="12">
                    <div className="form-group">
                      <label className="form-label" htmlFor="warehouseId">
                        Đến kho <span className="text-danger">*</span>
                      </label>
                      <div className="form-control-wrap">
                        <Controller
                          control={control}
                          name="toWarehouseId"
                          rules={{ required: "Vui lòng nhập thông tin" }}

                          render={({ onChange, value, name, ref }) => (
                            <RSelect
                              isClearable
                              classNamePrefix="form-control"
                              inputRef={ref}
                              name={name}
                              options={warehouseOptions.filter(e => e.value !== fromWarehouseId)}
                              value={warehouseOptions.find(
                                (c) => c.value === value
                              ) || null}
                              onChange={(val) => {
                                onChange(val?.value);
                              }}
                            />
                          )}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="warehouseId"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col md="12">
                    <div className="form-group">
                      <label className="form-label">
                        Loại <span className="text-danger">*</span>
                      </label>
                      <div className="form-control-wrap">
                        <Controller
                          control={control}
                          name="category"
                          rules={{ required: "Vui lòng nhập thông tin" }}
                          render={({ onChange, value, name, ref }) => (
                            <RSelect
                              ref={ref}
                              name={name}
                              options={INVENTORY_FUEL_CATEGORY_OPTIONS}
                              value={INVENTORY_FUEL_CATEGORY_OPTIONS.find(
                                (c) => c.value === value
                              )}
                              onChange={(val) => onChange(val?.value)}

                            />
                          )}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="category"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>

                  <Col md="12">
                    <div className="form-group">
                      <label className="form-label" htmlFor="customer">
                        Số lượng
                        <span className="text-danger">*</span>
                      </label>
                      <div className="form-control-wrap">
                        <Controller
                          control={control}
                          name="quantity"
                          rules={{ required: "Vui lòng nhập thông tin" }}
                          render={({ onChange, value, ref }) => (
                            <NumericFormat
                              className="form-control"
                              inputRef={ref}
                              type="text"
                              value={value}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                              onValueChange={(val) =>
                                onChange(val.floatValue)
                              }
                            />
                          )}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="quantity"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col size="12">
                    <Button color="primary" type="submit" disabled={loading}>
                      <span>Chuyển</span>
                    </Button>
                  </Col>
                </Row>
              </form>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ExchangeInventory;